import { api } from "../../index";
import { setCsrfToken } from "../../session";
import type { SessionResult } from "../../../context/AuthContext";

export interface LoginResult { mfaRequired: false; session: SessionResult; }
export interface MfaRequiredResult { mfaRequired: true; email: string; }
export const login = async (email: string, password: string): Promise<LoginResult | MfaRequiredResult> => {
  try {
    const response = await api.post("/login", { email, senha: password });
    if (response.status === 202) return { mfaRequired: true, email };
    const session = response.data as SessionResult;
    if (!session?.csrfToken || !session?.user || !session?.expiresAt) {
      throw Object.assign(new Error("Resposta de login inválida."), { code: "INVALID_LOGIN_RESPONSE" });
    }
    setCsrfToken(session.csrfToken);
    return { mfaRequired: false, session };
  } catch (error: any) {
    if (error.response?.status === 403 && String(error.response?.data?.message).startsWith("Conta não verificada")) error.isUnverified = true;
    throw error;
  }
};
